import type { useAmelioTranslations } from '@/hooks';
import type { MultilingualLabel } from '@/types/Locale';

export const formatMilestoneSentOn = (
    value: Date | undefined,
    calendarLocale: string,
    t: ReturnType<typeof useAmelioTranslations>['t'],
): string => {
    if (!value) {
        return t('cycleEvaluationSchedule.launchSummary.schedule.noDate');
    }

    const dateTime = value.toLocaleString(calendarLocale, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });

    return t('cycleEvaluationSchedule.launchSummary.schedule.sentOn', { date: dateTime });
};

export const resolveEmailBody = (
    value: string | MultilingualLabel | Record<string, string> | null | undefined,
): string => {
    if (!value) {
        return '';
    }

    return typeof value === 'string' ? value : Object.values(value).find((entry) => entry) || '';
};
